module.exports = __webpack_public_path__ + "img/3.1be5237f.jpg";